import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import APIRequests from '../../utility/APIRequests';

function* onChattyLoad(action) {
  try {
    const response = yield (new APIRequests).runGet("chatty/load");
    return action.callback?.(response);
  } catch (error) {
    return action.callback?.(error.response ?? error.message);
  }
}

function* onChattyGetMessages(action) {
  try {
    const response = yield (new APIRequests).runGet(`chatty/messages/${action.chattyId}`);
    return action.callback?.(response);
  } catch (error) {
    return action.callback?.(error.response ?? error.message);
  }
}

function* onChattySendMessage(action) {
  try {
    const response = yield (new APIRequests).runPost("chatty/message", {
      chattyId: action.chattyId,
      message: action.message,
    });
    return action.callback?.(response);
  } catch (error) {
    return action.callback?.(error.response ?? error.message);
  }
}

function* onChattyGetEarnings(action) {
  try {
    const response = yield (new APIRequests).runGet(`chatty/earnings/${action.chattyId}`);
    return action.callback?.(response);
  } catch (error) {
    return action.callback?.(error.response ?? error.message);
  }
}

function* watchOnChattyLoad() {
  yield takeEvery(actionTypes.CHATTY_LOAD, onChattyLoad);
}

function* watchOnChattyGetMessages() {
  yield takeEvery(actionTypes.CHATTY_GET_MESSAGES, onChattyGetMessages);
}

function* watchOnChattyGetEarnings() {
  yield takeEvery(actionTypes.CHATTY_GET_EARNINGS, onChattyGetEarnings);
}

function* watchOnChattySendMessage() {
  yield takeEvery(actionTypes.CHATTY_SEND_MESSAGE, onChattySendMessage);
}

export default function* chattySagas() {
  yield all([
    watchOnChattyLoad(),
    watchOnChattyGetMessages(),
    watchOnChattyGetEarnings(),
    watchOnChattySendMessage(),
  ]);
}
